module.exports = __webpack_public_path__ + "img/pro_capture0.82d8ed69.png";